(() => {
  const bbbioRoot = document.querySelector('[data-bbbio-crispr-request-form]');
  if (!bbbioRoot) return;

  const bbbioForm = bbbioRoot.querySelector('#bbbio-crispr-service-form');
  const bbbioProjectList = bbbioRoot.querySelector('[data-bbbio-crispr-project-list]');
  const bbbioProjectTemplate = bbbioRoot.querySelector('[data-bbbio-crispr-project-template]');
  const bbbioStatus = bbbioRoot.querySelector('[data-bbbio-crispr-status]');
  const bbbioAddProjectButton = bbbioRoot.querySelector('[data-bbbio-crispr-add-project]');
  const bbbioDownloadButton = bbbioRoot.querySelector('[data-bbbio-crispr-download]');
  const bbbioPrintButton = bbbioRoot.querySelector('[data-bbbio-crispr-print]');
  const bbbioContactName = bbbioRoot.querySelector('[data-bbbio-crispr-contact-name]');
  const bbbioContactEmail = bbbioRoot.querySelector('[data-bbbio-crispr-contact-email]');
  const bbbioContactPhone = bbbioRoot.querySelector('[data-bbbio-crispr-contact-phone]');
  const bbbioContactBody = bbbioRoot.querySelector('[data-bbbio-crispr-contact-body]');
  const bbbioAuthorizationDate = bbbioRoot.querySelector('#bbbio-crispr-authorization-date');
  if (!bbbioForm || !bbbioProjectList || !bbbioProjectTemplate || !bbbioStatus || !bbbioAddProjectButton || !bbbioDownloadButton || !bbbioPrintButton || !bbbioContactName || !bbbioContactEmail || !bbbioContactPhone || !bbbioContactBody) return;

  const bbbioToIdPart = (bbbioValue) => bbbioValue
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/[^a-zA-Z0-9-]+/g, '-')
    .toLowerCase();

  const bbbioSetStatus = (bbbioMessage, bbbioState = '') => {
    bbbioStatus.textContent = bbbioMessage;
    bbbioStatus.dataset.bbbioVisible = bbbioMessage ? 'true' : 'false';
    if (bbbioState) bbbioStatus.dataset.bbbioState = bbbioState;
    else delete bbbioStatus.dataset.bbbioState;
    bbbioStatus.setAttribute('role', bbbioState === 'error' ? 'alert' : 'status');
    bbbioStatus.setAttribute('aria-live', bbbioState === 'error' ? 'assertive' : 'polite');
  };

  const bbbioScrollToStatus = () => {
    const bbbioBehavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    bbbioStatus.scrollIntoView({ behavior: bbbioBehavior, block: 'center' });
  };

  const bbbioRenumberProjects = () => {
    const bbbioCards = [...bbbioProjectList.querySelectorAll('.bbbio-sample-card')];
    bbbioCards.forEach((bbbioCard, bbbioIndex) => {
      const bbbioNumber = bbbioIndex + 1;
      bbbioCard.dataset.bbbioProjectIndex = String(bbbioNumber);
      bbbioCard.querySelector('[data-bbbio-project-number]').textContent = String(bbbioNumber);
      bbbioCard.querySelectorAll('[data-bbbio-field]').forEach((bbbioField) => {
        const bbbioKey = bbbioField.dataset.bbbioField;
        const bbbioId = `${bbbioRoot.id}-project-${bbbioNumber}-${bbbioToIdPart(bbbioKey)}`;
        bbbioField.id = bbbioId;
        bbbioField.name = `project_${bbbioNumber}_${bbbioKey}`;
        const bbbioLabel = bbbioCard.querySelector(`[data-bbbio-label-for="${bbbioKey}"]`);
        if (bbbioLabel) bbbioLabel.htmlFor = bbbioId;
      });
      const bbbioRemoveButton = bbbioCard.querySelector('[data-bbbio-remove-project]');
      bbbioRemoveButton.disabled = bbbioCards.length === 1;
      bbbioRemoveButton.setAttribute('aria-label', `Remove editing project ${bbbioNumber}`);
    });
  };

  const bbbioAddProject = (bbbioShouldFocus) => {
    const bbbioFragment = bbbioProjectTemplate.content.cloneNode(true);
    const bbbioCard = bbbioFragment.querySelector('.bbbio-sample-card');
    bbbioCard.querySelector('[data-bbbio-remove-project]').addEventListener('click', () => {
      if (bbbioProjectList.querySelectorAll('.bbbio-sample-card').length > 1) {
        bbbioCard.remove();
        bbbioRenumberProjects();
      }
    });
    bbbioProjectList.appendChild(bbbioFragment);
    bbbioRenumberProjects();
    if (bbbioShouldFocus) bbbioCard.querySelector('[data-bbbio-field="projectId"]').focus();
  };

  const bbbioFormValue = (bbbioData, bbbioKey) => bbbioData.get(bbbioKey) || '';

  const bbbioCollectData = () => {
    const bbbioFormData = new FormData(bbbioForm);
    const bbbioSubmission = {
      submittedAt: new Date().toISOString(),
      customer: {},
      services: bbbioFormData.getAll('submissionServices'),
      project: {},
      editingProjects: [],
      shipping: {},
      authorization: {},
      laboratoryUseOnly: {}
    };
    ['organization', 'department', 'contactName', 'email', 'phone', 'customerAccount', 'address', 'poNumber', 'quoteNumber']
      .forEach((bbbioKey) => { bbbioSubmission.customer[bbbioKey] = bbbioFormValue(bbbioFormData, bbbioKey); });
    ['projectStage', 'turnaround', 'projectSummary', 'successCriteria']
      .forEach((bbbioKey) => { bbbioSubmission.project[bbbioKey] = bbbioFormValue(bbbioFormData, bbbioKey); });
    bbbioProjectList.querySelectorAll('.bbbio-sample-card').forEach((bbbioCard, bbbioIndex) => {
      const bbbioProject = { projectNumber: bbbioIndex + 1 };
      bbbioCard.querySelectorAll('[data-bbbio-field]').forEach((bbbioField) => {
        bbbioProject[bbbioField.dataset.bbbioField] = bbbioField.value;
      });
      bbbioSubmission.editingProjects.push(bbbioProject);
    });
    ['shipDate', 'carrier', 'tracking', 'shipCondition', 'suppliedMaterial', 'returnMaterial', 'shippingNotes', 'deliveryNotes']
      .forEach((bbbioKey) => { bbbioSubmission.shipping[bbbioKey] = bbbioFormValue(bbbioFormData, bbbioKey); });
    bbbioSubmission.shipping.deliverables = bbbioFormData.getAll('deliverables');
    ['authorizedName', 'authorizedTitle', 'authorizationDate', 'electronicSignature']
      .forEach((bbbioKey) => { bbbioSubmission.authorization[bbbioKey] = bbbioFormValue(bbbioFormData, bbbioKey); });
    bbbioSubmission.authorization.attestAccurate = bbbioRoot.querySelector('#bbbio-crispr-attest-accurate').checked;
    bbbioSubmission.authorization.attestIdentifiers = bbbioRoot.querySelector('#bbbio-crispr-attest-identifiers').checked;
    bbbioSubmission.authorization.attestHazards = bbbioRoot.querySelector('#bbbio-crispr-attest-hazards').checked;
    bbbioSubmission.authorization.attestResearchUse = bbbioRoot.querySelector('#bbbio-crispr-attest-research').checked;
    ['accessionNumber', 'receivedDate', 'receivedBy', 'condition', 'temperature', 'acceptance', 'labNotes']
      .forEach((bbbioKey) => { bbbioSubmission.laboratoryUseOnly[bbbioKey] = bbbioFormValue(bbbioFormData, bbbioKey); });
    return bbbioSubmission;
  };

  const bbbioValidate = () => {
    bbbioSetStatus('');
    if (!bbbioForm.reportValidity()) {
      bbbioSetStatus('Complete all required fields before submitting the request.', 'error');
      return false;
    }
    if (!bbbioRoot.querySelector('[data-bbbio-crispr-services] input:checked')) {
      bbbioSetStatus('Select at least one requested gene-editing service.', 'error');
      bbbioRoot.querySelector('[data-bbbio-crispr-services] input').focus();
      return false;
    }
    return true;
  };

  bbbioAddProjectButton.addEventListener('click', () => bbbioAddProject(true));
  bbbioPrintButton.addEventListener('click', () => window.print());
  bbbioDownloadButton.addEventListener('click', () => {
    if (!bbbioValidate()) { bbbioScrollToStatus(); return; }
    const bbbioBlob = new Blob([JSON.stringify(bbbioCollectData(), null, 2)], { type: 'application/json' });
    const bbbioUrl = URL.createObjectURL(bbbioBlob);
    const bbbioLink = document.createElement('a');
    bbbioLink.href = bbbioUrl;
    bbbioLink.download = `crispr-gene-editing-request-${Date.now()}.json`;
    document.body.appendChild(bbbioLink);
    bbbioLink.click();
    bbbioLink.remove();
    URL.revokeObjectURL(bbbioUrl);
    bbbioSetStatus('Submission JSON downloaded.', 'success');
  });
  bbbioForm.addEventListener('submit', (bbbioEvent) => {
    if (!bbbioValidate()) {
      bbbioEvent.preventDefault();
      bbbioScrollToStatus();
      return;
    }
    bbbioContactName.value = bbbioForm.elements.contactName.value;
    bbbioContactEmail.value = bbbioForm.elements.email.value;
    bbbioContactPhone.value = bbbioForm.elements.phone.value;
    bbbioContactBody.value = `GENE EDITING (CRISPR) SERVICE REQUEST\n\n${JSON.stringify(bbbioCollectData(), null, 2)}`;
    bbbioSetStatus('Submitting your request securely…', 'success');
  });
  bbbioForm.addEventListener('reset', () => window.setTimeout(() => {
    bbbioProjectList.replaceChildren();
    bbbioAddProject(false);
    bbbioSetStatus('');
    if (bbbioAuthorizationDate) bbbioAuthorizationDate.valueAsDate = new Date();
  }, 0));

  if (bbbioAuthorizationDate) bbbioAuthorizationDate.valueAsDate = new Date();
  bbbioAddProject(false);
})();
